export default __webpack_public_path__ + "static/image-product-feedback-368273cc3ab68b070af09582f72d3161.png";